module.exports = __webpack_public_path__ + "img/notification.be83e459.svg";